import { render, staticRenderFns } from "./TableEmployees.vue?vue&type=template&id=70c97916"
import script from "./TableEmployees.vue?vue&type=script&lang=js"
export * from "./TableEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports